export class AnimatedLayer {
  public name: string;
  public frames: any[] = [];
  public opacity: any;
  private interval: any;

  public startAnimation(waitTime: number): void {
    const stepTime = 1000;

    let currentOffset = 0;
    let previousOffset = currentOffset;

    setTimeout(() => {
      this.interval = setInterval(() => {
        previousOffset = currentOffset;
        currentOffset += 1;

        if (currentOffset === this.frames.length - 1) {
          currentOffset = 0;
        }

        this.frames[previousOffset].setOpacity(0);
        this.frames[currentOffset].setOpacity(this.opacity);
      }, stepTime);
    }, waitTime);
  }

  public stopAnimation(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.frames.length > 0) {
      for (let frame of this.frames) {
        frame.setOpacity(0);
      }

      this.frames[this.frames.length - 1].setOpacity(this.opacity);
    }
  }
}
